<template>
  <div class="sideMenu">
    <label v-for="menu in data" :key="menu.id">
      <!--首页特殊处理-->
<!--      <el-menu-item v-if="menu.id==1" :class="menu.style" style="font-size: 18px;" index="menu.id" @click="jumpPage(menu.url)">-->
<!--        <span slot="title">{{menu.name}}</span>-->
<!--      </el-menu-item>-->
      <!--类型为目录-->
      <el-submenu :index="menu.id.toString()" v-if="menu.type === 1">
        <template slot="title">
          <i :class="menu.icon"></i>
          <span>{{menu.label}}</span>
        </template>
        <label>
          <sideMenu :data="menu.children"></sideMenu>
        </label>
      </el-submenu>
      <!--类型为菜单-->
      <el-menu-item v-if="menu.type === 2" :index="menu.id.toString()" @click="jumpPage(menu.url)">
        <span slot="title">{{menu.label}}</span>
      </el-menu-item>
    </label>
  </div>
</template>

<script>
import sideMenu from "@/components/template/SideMenu";
export default {
  name: "sideMenu",
  data() {
    return {
      menu_data: {}
    };
  },
  components: {
    sideMenu: sideMenu
  },
  props: ["data"],
  methods: {
    jumpPage(page) {
      //用vue路由跳转到后台主界面
      this.$router.push({path: page});
    },
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/template/SideMenu.vue